import { checkedAddressSchema } from '@sparkdotfi/common-universal'
import { z } from 'zod'

import { hexSchema, normalizedNumberSchema } from '@/domain/common/validation'

export const airdropBreakdownResponseSchema = z.array(
  z.object({
    type: z.string(),
    groups: z.array(
      z.object({
        tag: z.string(),
        value: normalizedNumberSchema,
      }),
    ),
    root_hash: hexSchema,
    epoch: z.number(),
    wallet_address: checkedAddressSchema,
    token_address: checkedAddressSchema,
    amount_normalized: normalizedNumberSchema,
    proof: z.array(hexSchema),
    restricted_country_codes: z.array(z.string()),
  }),
)

export type AirdropBreakdownResponse = z.infer<typeof airdropBreakdownResponseSchema>
export type AirdropBreakdownRawResponse = z.input<typeof airdropBreakdownResponseSchema>
